import { motion } from "framer-motion";
import { Gem, Crown, Shirt, Sparkles } from "lucide-react";

const services = [
  {
    id: "custom-clothing",
    icon: Shirt,
    title: "Custom Clothing",
    description: "Unique, one-of-a-kind pieces designed specifically for you. From casual wear to statement pieces that turn heads.",
    image: "https://images.pexels.com/photos/30315263/pexels-photo-30315263.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "prom-dresses",
    icon: Crown,
    title: "Prom Dresses",
    description: "Make your special night unforgettable with a custom-designed prom dress that reflects your unique style and personality.",
    image: "https://customer-assets.emergentagent.com/job_threaded-events/artifacts/nnkd6ir6_IMG_1772.jpeg",
  },
  {
    id: "custom-caps",
    icon: Gem,
    title: "Custom Blinged Caps",
    description: "Rhinestones, jewels, and pure glamour. Our signature custom caps are handcrafted with premium embellishments.",
    image: "https://customer-assets.emergentagent.com/job_threaded-events/artifacts/ugnd4mmx_IMG_1950.jpeg",
  },
  {
    id: "custom-shoes",
    icon: Sparkles,
    title: "Custom Shoes",
    description: "Transform your kicks with chains, pearls, charms, and custom embellishments. Stand out with shoes that are uniquely you.",
    image: "https://customer-assets.emergentagent.com/job_threaded-events/artifacts/ea1g20bl_Custom%20Shoes.jpg",
  },
];

const ServicesSection = () => {
  return (
    <section id="services" data-testid="services-section" className="py-20 md:py-32 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16 md:mb-24"
        >
          <Sparkles className="w-8 h-8 text-rose mx-auto mb-4" />
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl mb-4">
            Our <span className="text-rose">Services</span>
          </h2>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            Bringing your fashion dreams to life with custom designs and premium craftsmanship
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              data-testid={`service-card-${service.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="service-card group"
            >
              {/* Image */}
              <div className="relative h-64 mb-6 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
                <div className="absolute top-4 right-4 p-3 glass-card">
                  <service.icon className="w-6 h-6 text-rose" />
                </div>
              </div>

              {/* Content */}
              <h3 className="font-heading text-2xl mb-3 group-hover:text-rose transition-colors">
                {service.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed">
                {service.description}
              </p>

              {/* Decorative line */}
              <div className="mt-6 h-px w-0 group-hover:w-full bg-gradient-to-r from-rose to-transparent transition-all duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
